import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.scss';

const Navbar = () => (
  <nav className="navbar">
    <div className="navbar__logo">
      <Link to="/">
        <img src="/assets/logo.png" alt="Yoospeak Logo" height="40" />
      </Link>
    </div>
    <ul className="navbar__menu">
      <li><Link to="/">Home</Link></li>
      <li><Link to="/marketplace">Marketplace</Link></li>
      <li><Link to="/mentors">Mentors</Link></li>
      <li><Link to="/about">About</Link></li>
    </ul>
    <div className="navbar__auth">
      <Link to="/login" className="navbar__login">Login</Link>
      <Link to="/signup" className="navbar__signup">Sign Up</Link>
    </div>
  </nav>
);

export default Navbar;
